import { render, staticRenderFns } from "./declareOk.vue?vue&type=template&id=2f6e07b5&"
import script from "./declareOk.vue?vue&type=script&lang=js&"
export * from "./declareOk.vue?vue&type=script&lang=js&"
import style0 from "./declareOk.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports